<template>
	<div style="min-width: 500px; min-height: 200px;">
		<div>
			<BaseSelect
				ref="BaseInput.companyType"
				:label="$t('invite_company_type').toString()"
				:options="companyTypeOptions"
				v-model="companyType"
				track-by="value"
				options-label="name"
				:required="true"
				:multiple="false"
			/>
			<BaseInput :label="$t('company_name').toString()" v-model="companyName" ref="BaseInput.companyName" :required="true" />
			<BaseInput
				:label="$t('e_mail').toString()"
				v-model="targetEmail"
				:required="true"
				ref="BaseInput.companyEmail"
				type="email"
				validationtype="email"
			/>
		</div>
		<div class="flex justify-end">
			<BaseButton class="btn-blue" @click="send" v-bind="$attrs" :is-loading="isLoading">
				{{ $t('invite').toString() }}
			</BaseButton>
		</div>
	</div>
</template>

<script>
import Authentication from '@/mixins/Authentication';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import Validate from '@/mixins/Validate';
import InvitationsRepository from '@/api/repositories/InvitationsRepository';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';

export default {
	name: 'InviteModal',
	components: { BaseSelect, BaseInput, BaseButton },
	mixins: [Validate, Authentication],

	data() {
		return {
			isLoading: false,
			companyName: '',
			targetEmail: '',
			companyTypeOptions: [
				{ name: 'Reparaturbetrieb', value: 'repairshop' },
				{ name: 'Autohaus', value: 'cardealer' },
			],
			companyType: { name: 'Reparaturbetrieb', value: 'repairshop' },
		};
	},
	methods: {
		send() {
			const isValid = this.validate();
			if (isValid) {
				this.isLoading = true;
				const data = {
					company_name: this.companyName,
					target_email: this.targetEmail,
					company_type: this.companyType.value,
				};

				new InvitationsRepository()
					.sendInvitation(data)
					.then(response => {
						this.isLoading = false;

						this.$swal({
							title: this.$t('general.success'),
							text: this.$t('invite_send_successfully'),
							icon: 'success',
						}).then(response => {
							this.$store.commit('setConfirmLeaving', false);
							this.$router.back();
						});
					})
					.catch(error => {
						if (error.response.status === 422) {
							let message = '';
							if (error.response.data?.error_codes?.target_email?.includes('invalid-email')) {
								message = $t('e_mail_not_valid');
							} else if (error.response.data?.error_codes?.target_email?.includes('duplicate-user-email')) {
								message = this.$t('e_mail_address_exists');
							} else if (error.response.data?.error_codes?.target_email?.includes('duplicate-invitation-email')) {
								message = this.$t('e_mail_address_already_invited');
							} else {
								message = this.$t('error_occurred');
							}
							this.isLoading = false;
							this.$swal({
								title: this.$t('general.error'),
								text: message,
								icon: 'error',
							}).then(response => {
								//this.$router.back();
							});
						} else {
							this.isLoading = false;
							this.$swal({
								title: this.$t('general.error'),
								text: this.$t('invite_send_failed'),
								icon: 'error',
							}).then(response => {
								//this.$router.back();
							});
						}
					});
			}
		},
	},
};
</script>
